<template>
    <v-app class="hidescroll main-style" >        
        <router-view>

        </router-view>
    </v-app>
</template>

<script>
    import Home from './components/Home.vue';
    export default {
        name: 'app',
        //title: "آساسرویس",
        metaInfo: {
            title: 'آساسرویس',
            titleTemplate: '%s |برنامه تعویض روغنی',
        },
        components: { Home },
    };
</script>

<style>
    @font-face {
        font-family: 'a_iranian_sansregular';
        src: url("./assets/fonts/IRANSansWeb.woff") format("woff");
    }

    @font-face {
        font-family: 'Yekan-Bakh-Regular';
        src: url("./assets/fonts/YekanBakhRegular.woff") format("woff");
    }

    @font-face {
        font-family: 'A.RaiMediaBlack_p30download.com';
        src: url("./assets/fonts/A.RaiMediaBlack_p30download.com.woff") format("woff");
    }

    .main-style {
        font-family: 'a_iranian_sansregular' !important;
        direction: rtl;
        background-color: #F5F7FA !important;
    }

    .drawer-text {
        color: white;
        text-align: right;
    }

    .v-application {
        font-size: 13px !important;
    }
</style>

